import {
  Cloud,
  CloudDrizzle,
  CloudFog,
  CloudHail,
  CloudLightning,
  CloudMoon,
  CloudRain,
  CloudRainWind,
  CloudSnow,
  CloudSun,
  Moon,
  Sun,
  Thermometer,
  type LucideIcon,
} from 'lucide-react';
import type { WeatherCondition } from '../../../shared/domain/index.ts';

const DAY_ICONS: Readonly<Record<WeatherCondition, LucideIcon>> = {
  clear: Sun,
  partly_cloudy: CloudSun,
  cloudy: Cloud,
  fog: CloudFog,
  drizzle: CloudDrizzle,
  rain: CloudRain,
  heavy_rain: CloudRainWind,
  snow: CloudSnow,
  sleet: CloudHail,
  freezing_rain: CloudHail,
  thunderstorm: CloudLightning,
  unknown: Thermometer,
};

const NIGHT_ICONS: Readonly<Partial<Record<WeatherCondition, LucideIcon>>> = {
  clear: Moon,
  partly_cloudy: CloudMoon,
};

export function WeatherIcon({ condition, isDay, size }: { condition: WeatherCondition; isDay: boolean; size: number }) {
  const Icon = (isDay ? undefined : NIGHT_ICONS[condition]) ?? DAY_ICONS[condition];
  return <Icon size={size} aria-hidden="true" />;
}
